<template>
    <div class="topbar-container">
        <zbList v-model="store" class="v-list" :isKeep="true" :isCustom="true" :message="message">
            <div class="list-item">
                <div class="r16 item bh bstart bbzlog fz_30">
                    <span>小八租车</span>
                    <div class="ico-bbzlog bg-contain"></div>
                    <span class="c_red fwb">4.9分</span>
                </div>
            </div>
            <div v-for="(item,i) in store.data" :key="i" class="list-item">
                <div class="r16 item" @click="onItemClick(item)">
                    <div class="time c_666 fz_28 border-bottom">{{item.createAt}}&emsp;下单</div>
                    <div class="fz_30 bh bstart title">
                        <div class="ico-scootertype left-ico bg-contain"></div>
                        <div class="b1">{{item.realCarType||'暂无车型'}}</div>
                        <span class="c_red fz_32">{{item.statusText}}</span>
                        <div class="ico-compNext bg-contain"></div>
                    </div>
                    <div class="fz_30 bh bstart text">
                        <div class="ico-take left-ico bg-contain"></div>
                        取车&emsp;{{item.getCarCity}}&emsp;{{item.getCarDate}}
                    </div>
                    <div class="fz_30 bh bstart text">
                        <div class="ico-also left-ico bg-contain"></div>
                        还车&emsp;{{item.returnCarCity}}&emsp;{{item.returnCarDate}}
                    </div>
                </div>
            </div>
            <div slot="empty">
                <!-- 如果数据为空，并且不在加载状态 -->
                <div v-show="!store.data.length&&!store.isLoading" class="noMessage">
                    <div class="bv bc message-content">
                        <div class="empty-img bg-contain"></div>
                        <div class="fz_34 c_333">暂无订单</div>
                        <div class="fz_24 c_999 more">“赶紧去下一单吧”</div>
                        <van-button class="btn btn-empty" @click="backGo">立即租车</van-button>
                    </div>
                </div>
            </div>
        </zbList>
    </div>
</template>
<script>
import { orderList } from "@/api/scooter";
import { list } from "@/mixin/list";
import { user } from "@/mixin/user";
import zbList from "@/components/data/List";
export default {
    mixins: [list, user],
    name: "ScooterOrderList",
    components: { zbList },
    data() {
        return {
            message: {
                noMore: "没有更多订单了",
                finished: "没有更多订单了"
            },
            store: {
                proxy: {
                    getList: orderList,
                    disposeItem(item) {
                        // 状态 0 待审核 1 待排车 2 待取车 3 待还车 4 待结算 5 已完成 -1 已取消
                        item.statusText =
                            [
                                "待审核",
                                "待排车",
                                "待取车",
                                "待还车",
                                "待结算",
                                "已完成"
                            ][item.status] || "已取消";
                    }
                }
            }
        };
    },
    computed: {
        isUpdateOrderList() {
            return this.$store.state.scooter.isUpdateOrderList;
        }
    },
    watch: {
        isUpdateOrderList(v) {
            if (v) {
                this.storeReLoad();
                this.$store.state.scooter.isUpdateOrderList = false;
            }
        }
    },
    methods: {
        // 获取用户数据后执行
        userLoginend() {
            this.storeLoad();
        },
        // 查看详情
        onItemClick(item) {
            this.$router.push({
                name: "ScooterOrderInfo",
                params: {
                    id: item.orderNo
                }
            });
        }
    }
};
</script>
<style scoped lang="scss">
.v-list {
    background-color: #f7f8f8;
    .list-item {
        padding: 24px 30px 0 30px;
        .item {
            padding: 30px;
            background-color: #fff;
        }
        .time {
            padding-bottom: 23px;
        }
        .title {
            padding: 20px 0 5px 0;
        }
        .text {
            padding: 5px 0;
        }
        .border-bottom:after {
            width: 100%;
            left: 0;
        }
        .left-ico {
            width: 32px;
            height: 32px;
            margin-right: 8px;
        }
        .ico-compNext {
            width: 16px;
            height: 30px;
            margin-left: 12px;
        }
    }
}
.btn-empty {
    width: 180px;
    height: 68px;
}
.empty-img {
    background-image: url("~@/assets/imges/scooter/nomessage.png");
    width: 240px;
    height: 250px;
    margin-bottom: 34px;
}
.more {
    margin: 30px 0 50px 0;
}
</style>
